export default __webpack_public_path__ + "static/security-2-6ca65635c8648b84bcb45461ffbadef1.png";